import { BaseRestRepository } from './baseRestRepository';
import type { EmailDto, FileDto, LeaseInvoiceDto } from '~/swagger/portal/Api';

const LEASES_URL = '/api/leases';
export class LeaseInvoiceRepository extends BaseRestRepository {
  public async getLeaseInvoice(leaseId: string, billId: string): Promise<LeaseInvoiceDto> {
    const url = `${LEASES_URL}/${leaseId}/bills/${billId}/invoice`;
    const response = await this.fetchWithAuth(
      url,
      {
        method: 'GET',
      },
      false
    );
    return this.getJsonResponse(response);
  }

  public async createLeaseInvoice(leaseId: string, billId: string): Promise<LeaseInvoiceDto> {
    const url = `${LEASES_URL}/${leaseId}/bills/${billId}/invoice`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
    });
    return this.getJsonResponse(response);
  }
  public async getLeaseInvoiceFile(leaseId: string, invoiceId: string): Promise<FileDto> {
    const url = `${LEASES_URL}/${leaseId}/invoices/${invoiceId}/file`;
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }

  public async send(leaseId: string, invoiceId: string): Promise<EmailDto> {
    const url = `${LEASES_URL}/${leaseId}/invoices/${invoiceId}/send`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({}),
    });
    return this.getJsonResponse(response);
  }
}

export const leaseInvoiceRepository = new LeaseInvoiceRepository();
